import { Shimmer } from '@components'
import React from 'react'
import { ENTRY_PANEL_SHIMMER_ROW_COUNT } from './entryPanelConstants'
import {
  AttachmentSlot,
  Caret,
  AccountCode,
  DateCell,
  EntryVoucherRow,
  ReportRow,
  RowLabel,
  ValueCell
} from './interactive.styled'

type LedgerShimmerProps = {
  rowCount?: number
}

export const LedgerEntryShimmerRows: React.FC<LedgerShimmerProps> = ({
  rowCount = ENTRY_PANEL_SHIMMER_ROW_COUNT
}) => (
  <>
    {Array.from({ length: rowCount }, (_, index) => (
      <ReportRow key={`ledger-shimmer-${index}`} $entryRow $bg="#f7fafd">
        <AttachmentSlot />
        <DateCell>
          <Shimmer width={72} height={12} borderRadius={4} />
        </DateCell>
        <EntryVoucherRow>
          <Shimmer width="70%" height={12} borderRadius={4} />
        </EntryVoucherRow>
        <ValueCell $width="110px">
          <Shimmer width={64} height={12} borderRadius={4} />
        </ValueCell>
        <ValueCell $width="110px">
          <Shimmer width={56} height={12} borderRadius={4} />
        </ValueCell>
        <ValueCell $width="128px">
          <Shimmer width={72} height={12} borderRadius={4} />
        </ValueCell>
      </ReportRow>
    ))}
  </>
)

type ReconciliationShimmerProps = {
  rowCount?: number
}

export const ReconciliationEntryShimmerRows: React.FC<ReconciliationShimmerProps> = ({
  rowCount = ENTRY_PANEL_SHIMMER_ROW_COUNT
}) => (
  <>
    {Array.from({ length: rowCount }, (_, index) => (
      <ReportRow key={`reconciliation-shimmer-${index}`} $entryRow $bg="#f7fafd">
        <AttachmentSlot />
        <DateCell>
          <Shimmer width={72} height={12} borderRadius={4} />
        </DateCell>
        <EntryVoucherRow>
          <Shimmer width="70%" height={12} borderRadius={4} />
        </EntryVoucherRow>
        <ValueCell $width="128px">
          <Shimmer width={72} height={12} borderRadius={4} />
        </ValueCell>
      </ReportRow>
    ))}
  </>
)

type JournalShimmerProps = {
  rowCount?: number
  statusIconWidth: string
}

export const JournalEntryShimmerRows: React.FC<JournalShimmerProps> = ({
  rowCount = ENTRY_PANEL_SHIMMER_ROW_COUNT,
  statusIconWidth
}) => (
  <>
    {Array.from({ length: rowCount }, (_, index) => (
      <ReportRow key={`journal-shimmer-${index}`} $entryRow $bg="#f7fafd">
        <Caret />
        <AccountCode>
          <Shimmer width={40} height={12} borderRadius={4} />
        </AccountCode>
        <RowLabel>
          <Shimmer width="55%" height={12} borderRadius={4} />
        </RowLabel>
        <ValueCell $width="120px">
          <Shimmer width={64} height={12} borderRadius={4} />
        </ValueCell>
        <ValueCell $width="120px">
          <Shimmer width={64} height={12} borderRadius={4} />
        </ValueCell>
        <ValueCell $width={statusIconWidth} />
      </ReportRow>
    ))}
  </>
)

type VatShimmerProps = {
  rowCount?: number
}

export const VatEntryShimmerRows: React.FC<VatShimmerProps> = ({
  rowCount = ENTRY_PANEL_SHIMMER_ROW_COUNT
}) => (
  <>
    {Array.from({ length: rowCount }, (_, index) => (
      <ReportRow key={`vat-shimmer-${index}`} $entryRow $bg="#f7fafd">
        <Caret />
        <DateCell>
          <Shimmer width={72} height={12} borderRadius={4} />
        </DateCell>
        <RowLabel>
          <Shimmer width="65%" height={12} borderRadius={4} />
        </RowLabel>
        <ValueCell>
          <Shimmer width={72} height={12} borderRadius={4} />
        </ValueCell>
      </ReportRow>
    ))}
  </>
)
